export default function getFontLocals(localAlias) {
  if (typeof localAlias === 'string') {
    return [localAlias];
  }

  if (Array.isArray(localAlias)) {
    return localAlias.slice();
  }

  return [];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/node_modules/fela/es/getFontLocals.js
// module id = 1093
// module chunks = 0